import { render, staticRenderFns } from "./BulkLinkSupplier.vue?vue&type=template&id=00a8c15a"
import script from "./BulkLinkSupplier.vue?vue&type=script&lang=js"
export * from "./BulkLinkSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports